import * as React from "react"

import { GetApi } from "../../../../../api/api"
import AppContext from "../../../../../components/AppContext"
import Button from "../../../../../components/Button"

interface CsvDownloadProps {
  fccId: string
  atId: number
  refresh: () => void
  disabled: boolean
  setDisabled: (value: boolean) => void
  children: any
  className?: string
}

class CsvDownload extends React.Component<CsvDownloadProps, {}> {
  public static contextType = AppContext

  constructor(props: CsvDownloadProps) {
    super(props)
  }

  public render() {
    return (
      <React.Fragment>
        <Button
          variant="secondary"
          onClick={this.downloadCSV}
          disabled={this.props.disabled}
          className={this.props.className}
        >
          {this.props.children}
        </Button>
      </React.Fragment>
    )
  }
  private downloadCSV = async () => {
    this.props.setDisabled(true)
    try {
      const apiImpl = await GetApi()
      const result = await apiImpl.getAttributeLegalValuesCsv(
        this.props.fccId,
        this.props.atId
      )
      const atbt = await apiImpl.getAttributeType(
        this.props.fccId,
        this.props.atId
      )
      const fileName = atbt.name + "_AllowedValues.csv"
      const blob = new Blob([result as BlobPart], { type: "octet/stream" })
      const a = document.createElement("a")
      document.body.appendChild(a)
      a.setAttribute("style", "display: none")
      const url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = fileName
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    } catch (error) {
      this.context.useToasts.addToast(error, "danger")
    } finally {
      this.props.setDisabled(false)
    }
  }
}

export default CsvDownload
